<!-- Tour Template -->
<tour-step-template>
    <ng-template let-step="step">
        <div class="tw-bg-white dark:tw-bg-gray-800 tw-rounded-xl tw-shadow-2xl tw-border tw-border-gray-200 dark:tw-border-gray-700 tw-overflow-hidden tw-transform tw-transition-all tw-duration-300 tw-ease-out"
            [class.tw-animate-fade-in-up]="true" [style.width]="step.stepDimensions?.width || '28rem'"
            [style.min-width]="step.stepDimensions?.minWidth || 'min(20rem, 90vw)'"
            [style.max-width]="step.stepDimensions?.maxWidth || '32rem'"
            [style.filter]="'drop-shadow(0 10px 15px rgba(0, 0, 0, 0.1))'" (click)="$event.stopPropagation()">

            <div class="tw-relative">
                <div
                    class="tw-absolute tw-inset-0 tw-bg-gradient-to-r tw-from-blue-500 tw-to-indigo-600 tw-opacity-10 dark:tw-opacity-20">
                </div>
                <div class="tw-flex tw-justify-between tw-items-center tw-px-5 tw-py-2.5 tw-relative">
                    <h3
                        class="tw-text-xl tw-font-semibold tw-text-gray-900 dark:tw-text-gray-100 tw-tracking-tight tw-mb-0 tw-truncate tw-max-w-[80%]">
                        {{ step.title }}
                    </h3>
                    <button
                        class="tw-p-1 tw-text-gray-400 hover:tw-text-gray-700 dark:hover:tw-text-gray-300 tw-transition-all tw-duration-200"
                        (click)="tourService.pause()" aria-label="Skip">
                        Skip
                    </button>
                </div>
            </div>

            <div
                class="tw-p-4 tw-max-h-[50vh] sm:tw-max-h-64 tw-overflow-y-auto custom-scrollbar dark:tw-scrollbar-dark">
                <div class="tw-text-gray-700 dark:tw-text-gray-300 tw-leading-relaxed tw-text-md tw-text-center"
                    [innerHTML]="step.content"></div>
            </div>

            <div
                class="tw-backdrop-blur-sm tw-bg-white/80 dark:tw-bg-gray-800/80 tw-border-t tw-border-gray-200 dark:tw-border-gray-700 tw-p-2">
                <div class="tw-flex tw-items-center tw-justify-between tw-gap-3">
                    <button
                        class="tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-gray-700 hover:tw-bg-gray-100/80 tw-rounded-lg tw-transition-all tw-duration-200"
                        [disabled]="!tourService.hasPrev(step)" (click)="tourService.prev()"
                        [class.tw-opacity-50]="!tourService.hasPrev(step)"
                        [class.tw-cursor-not-allowed]="!tourService.hasPrev(step)">
                        <svg xmlns="http://www.w3.org/2000/svg"
                            class="tw-h-5 tw-w-5 tw-stroke-gray-700 dark:tw-stroke-gray-200" fill="none"
                            viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                                d="M15 19l-7-7 7-7" />
                        </svg>
                    </button>

                    @if (step.showProgress) {
                    <div class="tw-flex tw-items-center tw-gap-2 tw-flex-1 tw-max-w-[120px] sm:tw-max-w-[160px]">
                        <div
                            class="tw-h-2 tw-bg-gray-200 dark:tw-bg-gray-700 tw-rounded-full tw-w-full tw-overflow-hidden">
                            <div class="tw-h-full tw-bg-gradient-to-r tw-from-blue-500 tw-to-indigo-600 tw-rounded-full tw-transition-all tw-duration-300"
                                [style.width]="((tourService.steps.indexOf(step) + 1) / tourService.steps.length) * 100 + '%'">
                            </div>
                        </div>
                        <span class="tw-text-xs tw-font-medium tw-text-gray-500 dark:tw-text-gray-400">
                            {{ tourService.steps.indexOf(step) + 1 }}/{{ tourService.steps.length }}
                        </span>
                    </div>
                    }

                    @if (tourService.hasNext(step) && !step.nextOnAnchorClick) {
                    <button
                        class="tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-gray-700 hover:tw-bg-gray-100/80 tw-rounded-lg tw-transition-all tw-duration-200"
                        (click)="tourService.next()">
                        <span  class="tw-text-gray-700 dark:tw-text-gray-200">Next</span>
                        <svg xmlns="http://www.w3.org/2000/svg"
                            class="tw-h-5 tw-w-5 tw-stroke-gray-700 dark:tw-stroke-gray-200" fill="none"
                            viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 5l7 7-7 7" />
                        </svg>
                    </button>
                    }

                    @if (!tourService.hasNext(step)) {
                    <button
                        class="tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-gray-700 hover:tw-bg-gray-100/80 tw-rounded-lg tw-transition-all tw-duration-200"
                        (click)="tourService.end()">
                        <span class="tw-text-blue-500">Finish</span>
                        <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-5 tw-w-5 tw-stroke-blue-500" fill="none"
                            viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                                d="M5 13l4 4L19 7" />
                        </svg>
                    </button>
                    }
                </div>
            </div>
        </div>
    </ng-template>
</tour-step-template>

<router-outlet></router-outlet>
